import { ReactElement, useEffect, useState } from "react";
import { Breadcrumb, Layout, Button, Row, Col, Form, Select, Input, Modal, Typography, Divider, Spin, message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import firebase from "firebase/app";
import Paper from "@material-ui/core/Paper";
import { capitalize } from "@material-ui/core";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";
import { ViewState, GroupingState, IntegratedGrouping, EditingState, IntegratedEditing } from "@devexpress/dx-react-scheduler";
import { Scheduler, Toolbar, Resources, Appointments, GroupingPanel, DayView, AppointmentTooltip } from "@devexpress/dx-react-scheduler-material-ui";
import api from "../../redux/api/axiosInstance";
import { getAuthState, getClubState } from "../../redux/selectors";
import { BreadCrumbWrapper } from "../../components/GlobalStyles";
import { SET_LOADING_STATE, RESET_LOADING_STATE, CREATE_BOOKING_REQUEST } from "../../redux/constants";
import { BookingTooltipHeader } from "../../components/Scheduler/BookingTooltipHeader";
import { BookingTooltipContent } from "../../components/Scheduler/BookingTooltipContent";
import { firebaseCreateBooking } from "../../redux/api/booking";

const { Option } = Select;
const { Content } = Layout;
const { Paragraph } = Typography;
const timePeriods = [30, 60, 90, 120];


const BookingContent = (props: any) => {
	const { children, style, data, ...restProps } = props;
	return (
		<Appointments.Appointment
			{...restProps}
			data={data}
			style={{
				...style,
				backgroundColor: data.createdBy === "manager" ? "#FFC107" : "#1597E5"
			}}
		>
			{children}
			<div style={{ marginLeft: 10 }}>
				<p style={{ color: "#fff" }}>{data.createdBy === "manager" ? "CM created" : ""}</p>
			</div>
		</Appointments.Appointment>
	);
};


export function Import(props: any): ReactElement {

	const [form] = Form.useForm();
	const { t } = useTranslation();
	const dispatch = useDispatch();

	const { currentUser } = useSelector(getAuthState);
	const { clubs } = useSelector(getClubState);
	const [currentClub, setCurrentClub] = useState<any>(clubs[0] || {});
	const [courtsOfBranch, setCourtsOfBranch] = useState<any[]>([]);
	const [slots, setSlots] = useState<any[]>([]);
	const [loading, setLoading] = useState<boolean>(false);
	const [selectedBranchId, setSelectedBranchId] = useState<string>();
	const [selectedCourtId, setSelectedCourtId] = useState<string>();
	const [selectedBookingDate, setSelectedBookingDate] = useState<any>(moment().toDate());
	const [selectedDuration, setSelectedDuration] = useState<number>(30);
	const [branches, setBranches] = useState<any[]>([]);
	const [courts, setCourts] = useState<any[]>([]);
	const [bookingsForSelectedBranch, setBookingsForSelectedBranch] = useState<any[]>([]);
	const [bookingTime, setBookingTime] = useState<string>("");
	const [booingDate, setBookingDate] = useState<string>(moment().format("YYYY-MM-DD"));
	const [schedule, setSchedule] = useState<any[]>([]);
	const [dateInterval, setDateInterval] = useState<number>(1);
	const [showScheduler, setShowScheduler] = useState<boolean>(false);
	const [showConfirmModal, setShowConfirmModal] = useState<boolean>(false);

	useEffect(() => {
		// Get clubs 
		dispatch({ type: SET_LOADING_STATE });
		api.post("getClub", { clubId: currentUser?.club })
			.then(res => {
				const branchesOfClub = res.data.branches;
				const courtsOfClub = res.data.courts;
				setBranches(branchesOfClub);
				setCourts(courtsOfClub.flat());
				dispatch({ type: RESET_LOADING_STATE })
			})
			.catch(e => {
				console.log(e);
				dispatch({ type: RESET_LOADING_STATE })
			})
	}, []);

	const getStartEndTime = (branchId: string, date: string): any => {
		const selectedBranch = branches.find(b => b.firestoreRef === branchId);
		let endTime = moment(`${date} ${selectedBranch?.endTime}`);
		const startTime = moment(`${date} ${selectedBranch?.startTime}`);

		if (date === moment().format("YYYY-MM-DD") && startTime < moment()) {
			// startTime = moment(`${date} ${moment().add(1, "h").format("HH:00")}`);
			// if (startTime.format("YYYY-MM-DD") !== moment().format("YYYY-MM-DD")) {
			// 	startTime = endTime;
			// }
		}
		if (startTime > endTime) {
			endTime = endTime.add(1, "d");
			setDateInterval(2);
		} else {
			setDateInterval(1);
		}
		return {
			startTime,
			endTime
		};
	}

	const getAllBookingForDate = async (branchId: string, date: string) => {
		const selectedBranch = branches.find(b => b.firestoreRef === branchId);
		const { startTime, endTime } = getStartEndTime(branchId, date);
		const filterDates = [startTime.format("YYYY-MM-DD"), endTime.format("YYYY-MM-DD")];
		const bookSnapshots = await firebase
			.firestore()
			.collection("bookings")
			.where("branchId", "==", selectedBranch?.firestoreRef)
			.where("date", "in", filterDates)
			.where("status", "!=", "cancelled")
			.get();
		const mBookingsForDate = bookSnapshots.docs.map((book) => book.data()).filter(b => b.courtId === selectedCourtId);
		const scheduleForDate = await Promise.all(
			bookSnapshots.docs.map(async (book, index) => {
				const bookData = book.data();
				const bookingStartDateTime = moment(`${bookData.date} ${bookData.start}`);
				const data: any = {
					id: bookData.bookingId,
					title: '',
					club: currentClub,
					...bookData,
					courts: [bookData.courtId],
					startDate: bookingStartDateTime.toDate(),
					endDate: bookingStartDateTime.add(bookData.period, "m").toDate(),
					user: bookData.user || null
				}
				if (bookData.user === undefined) {
					const userSnapshot = await firebase.firestore().collection("users").doc(bookData.userId).get();
					const userData = userSnapshot.data();
					data.user = userData;
					data.title = userData?.fullName;
				}
				return data;
			})
		)
		setBookingsForSelectedBranch(mBookingsForDate);
		setSchedule(() => scheduleForDate);
		setShowScheduler(true);
		return mBookingsForDate;
	}

	const getTimeSlots = async (branchId: string, courtId: string, duration: number, bookingDate: string) => {
		setLoading(true);
		setSlots([]);
		const mSlots: any[] = [];
		const { startTime, endTime } = getStartEndTime(branchId, bookingDate);
		const bookings = await getAllBookingForDate(branchId, bookingDate);
		const courtsIds = [courtId]
		let nextSlot = startTime;
		while (nextSlot < endTime) {
			const time = nextSlot.format("HH:mm:ss");
			const timeSlot = { time, timeText: nextSlot.format("h:mm A"), courts: courtsIds, date: nextSlot.format("YYYY-MM-DD") };
			mSlots.push(timeSlot);
			nextSlot = nextSlot.add(30, "m");
		}

		const spanSlot = duration / 30;

		courtsIds.forEach((pCourt) => {
			const pSlots = Array.from(mSlots);
			const pBookings = bookings.filter((b) => b.courtId === pCourt);
			pBookings.forEach((pb) => {
				const { start, date } = pb;
				const startSlotIndex = pSlots.findIndex((e) => e.time === start && e.date === date);
				const durationSpan = pb.period / 30;
				if (startSlotIndex === -1) return;
				for (let i = 0; i < durationSpan; i += 1) {
					if (i + startSlotIndex < mSlots.length) {
						mSlots[i + startSlotIndex].courts = mSlots[i + startSlotIndex].courts.filter((e: string) => e !== pCourt);
					}
				}
			});
			mSlots.forEach((ps, index) => {
				if (ps.courts.indexOf(pCourt) === -1) {
					for (let i = 1 - spanSlot; i < 0; i += 1) {
						if (i + index > -1 && i + index < mSlots.length) {
							mSlots[i + index].courts = mSlots[i + index].courts.filter((e: string) => e !== pCourt);
						}
					}
				}
			});
			// If duration is over 30 mins, it will disable last n(same as durationSpan - 1) slots
			const disableLastSlotsCount = mSlots.length > spanSlot ? spanSlot : mSlots.length;
			for (let i = 1; i < disableLastSlotsCount; i += 1) {
				mSlots[mSlots.length - i].courts = [];
			}
		});

		const currentTime = moment().format("H:mm:ss");
		const currentDate = moment().format("YYYY-MM-DD");

		setSlots(origin => {
			const availableSlots = mSlots.filter(s => {
				if (s.date === currentDate)
					return s.time > currentTime && s.courts.length > 0;
				return s.courts.length > 0;
			});
			return availableSlots;
		});

		setLoading(false);
	};

	const onChangeBranch = (branchId: any) => {
		setSelectedBranchId(branchId);
		const mCourts = courts.filter((court: any) => court.branchId === branchId).map(c => ({
			...c,
			text: `${c.name}(${capitalize(c.place)})`,
			id: c.courtId,
			color: 'blue'
		}));
		setCourtsOfBranch(mCourts);
		setSelectedCourtId(undefined);
	}
	const onChangeCourt = (courtId: string) => {
		setSelectedCourtId(courtId);
	}

	useEffect(() => {
		if (selectedBranchId && selectedCourtId && selectedDuration && selectedBookingDate) {
			getTimeSlots(selectedBranchId, selectedCourtId, selectedDuration, moment(selectedBookingDate).format("YYYY-MM-DD"));
		}
	}, [selectedBranchId, selectedCourtId, selectedDuration, selectedBookingDate])

	const onNextDate = () => {
		setLoading(true);
		setSelectedBookingDate((origin: any) => moment(origin).add(1, "d").toDate());
		setLoading(false);
		setBookingTime('');
	}

	const onPrevDate = () => {
		setLoading(true);
		setSelectedBookingDate((origin: any) => moment(origin).subtract(1, "d").toDate());
		setLoading(false);
		setBookingTime('');
	}

	const onPressConfirm = () => {
		setShowConfirmModal(true);
	}

	const onFinish = (values: any) => {
		const { info, fullName, email, gender, phoneNumber } = values;
		const newBooking = {
			bookingId: uuidv4(),
			userId: "",
			branchId: selectedBranchId,
			courtId: selectedCourtId,
			date: booingDate,
			period: selectedDuration,
			start: bookingTime,
			ball: false,
			club: currentClub.firestoreRef,
			price: currentClub.price[selectedDuration],
			currency: currentClub.currency,
			additionalInfo: info,
			createdAt: firebase.firestore.FieldValue.serverTimestamp(),
			user: {
				fullName,
				email,
				phoneNumber,
				gender
			},
			createdBy: "manager",
		};
		dispatch({ type: SET_LOADING_STATE });
		firebaseCreateBooking({ data: newBooking })
			.then(() => {
				if (selectedBranchId && selectedCourtId && selectedDuration && selectedBookingDate) {
					getTimeSlots(selectedBranchId, selectedCourtId, selectedDuration, moment(selectedBookingDate).format("YYYY-MM-DD"));
				}
				dispatch({ type: RESET_LOADING_STATE });
			})
			.catch(() => {
				dispatch({ type: RESET_LOADING_STATE });
			})
		form.resetFields();
		setShowConfirmModal(false);
		setBookingTime("");
	}

	const cancelBooking = (bookingId: string) => {
		dispatch({ type: SET_LOADING_STATE });
		api.post("/cancel_booking", { bookingId })
			.then(() => {
				if (selectedBranchId && selectedCourtId && selectedDuration && selectedBookingDate) {
					getTimeSlots(selectedBranchId, selectedCourtId, selectedDuration, moment(selectedBookingDate).format("YYYY-MM-DD"));
				}
				dispatch({ type: RESET_LOADING_STATE });
				message.success("Booking has been cancelled!");
			})
			.catch(e => {
				console.log("Error", e);
				dispatch({ type: RESET_LOADING_STATE });
				message.error("Oop! Something went wrong!");
			})
	};

	const onCommitChanges = (data: any) => {
		const { added, changed, deleted } = data;
		if (deleted !== undefined) {
			const confirm = window.confirm("Would you remove this booking?");
			if (confirm) {
				cancelBooking(deleted);
			}
		}
	};


	const setTimeSlot = (slot: any) => {
		setBookingTime(slot.time);
		setBookingDate(slot.date)
	}


	return (
		<Content>
			<BreadCrumbWrapper>
				<Breadcrumb style={{ fontSize: 18 }}>
					<Breadcrumb.Item>
						Import Booking
					</Breadcrumb.Item>
				</Breadcrumb>
			</BreadCrumbWrapper>
			<Row gutter={12}>
				<Col span={8}>
					<Paper style={{ padding: 20 }}>
						<Row gutter={8}>
							<Col span={24}>
								<div className="booking-header-title text-label">
									<span className="text-uppercase">{t("booking.select_date_time")}</span>
								</div>
							</Col>
							<Col span={12}>
								<Select style={{ width: "100%" }} placeholder="Please select a branch" onChange={onChangeBranch}>
									{branches.map((b: any) => <Option value={b.firestoreRef} key={b.branchId}>{b.location}</Option>)}
								</Select>
							</Col>
							<Col span={12}>
								<Select style={{ width: "100%" }} placeholder="Select a court" onChange={onChangeCourt} value={selectedCourtId}>
									{courtsOfBranch.map((c: any) => <Option value={c.courtId} key={c.courtId}>{c.name} ({c.place})</Option>)}
								</Select>
							</Col>
						</Row>
						<Row gutter={8} style={{ marginTop: 10 }}>
							{timePeriods.map((p) => (
								<Col span={6} className="time-slot-button-container" key={p}>
									<Button className={`time-slot-button ${selectedDuration === p ? "active" : ""}`} onClick={() => setSelectedDuration(p)}>
										{p}
										<p style={{ fontSize: 12 }}>{currentClub.price[p]} {currentClub.currency}</p>
									</Button>
								</Col>
							))}
						</Row>
						<Row style={{ marginTop: 20 }}>
							<Col span={4}>
								<Button
									className="booking-date-arrow-icon"
									style={{ float: "right" }}
									onClick={onPrevDate}
									disabled={loading}
								>
									<ArrowLeftOutlined />
								</Button>
							</Col>
							<Col span={16} style={{ textAlign: "center", fontWeight: 500 }}>
								<div>{moment(selectedBookingDate).format("dddd")}</div>
								<div>{moment(selectedBookingDate).format("MMMM D, YYYY")}</div>
							</Col>
							<Col span={4}>
								<Button
									className="booking-date-arrow-icon"
									style={{ float: "left" }}
									onClick={onNextDate}
									disabled={loading}
								>
									<ArrowRightOutlined />
								</Button>
							</Col>
						</Row>
						<Row style={{ marginTop: 20 }}>
							{slots.map((slot, index) => (
								<>
									<Col xs={12} key={slot.time} className="booking-time-slot-button-container">
										{bookingTime !== slot.time ?
											<Button className="booking-time-slot-button" onClick={() => setTimeSlot(slot)} disabled={slot.courts.length === 0}>
												{slot.timeText}
											</Button>
											: <Button className="booking-time-slot-confirm" type="primary" block onClick={onPressConfirm}>
												{t("booking.confirm")}
											</Button>
										}
									</Col>
									{(slots[index + 1] && slot.date !== slots[index + 1].date) && (
										<Col span={24}>
											<Divider style={{ borderColor: '#7cb305', fontWeight: 400, fontSize: 14 }} dashed>
												{moment(slots[index + 1].date).format("MMM DD, dddd")}
											</Divider>
										</Col>
									)}
								</>
							))}
							{(!loading && slots.length === 0) && (
								<Paragraph><pre>{t("booking.empty_slots")}</pre></Paragraph>
							)}
							{loading && <Col span={24} style={{ textAlign: "center", marginTop: 20 }}> <Spin tip="Loading..." /></Col>}
						</Row>
					</Paper>
				</Col>
				<Col span={16}>
					{showScheduler && <Paper style={{ padding: 20 }} >
						<div className="booking-header-title text-label">
							<span className="text-uppercase">{t("booking.booking_status")}</span>
							<p style={{ fontSize: 14, marginBottom: 0, fontWeight: 400 }}>{currentClub.name}, {branches.find(b => b.firestoreRef === selectedBranchId).location}</p>
						</div>
						<Scheduler data={schedule}>
							<ViewState
								currentDate={moment(selectedBookingDate).format("YYYY-MM-DD")} />
							<EditingState onCommitChanges={onCommitChanges} />
							<IntegratedEditing />
							<GroupingState grouping={[{ resourceName: "courts" }]} />
							<DayView
								startDayHour={0}
								endDayHour={24}
								cellDuration={60}
								intervalCount={dateInterval}
							/>
							<Appointments appointmentComponent={BookingContent} />
							<AppointmentTooltip
								headerComponent={BookingTooltipHeader}
								contentComponent={BookingTooltipContent}
								showDeleteButton
								showCloseButton
							/>
							<Resources
								data={[{
									fieldName: "courts",
									title: "Courts",
									instances: courtsOfBranch,
									allowMultiple: true,
								}]}
								mainResourceName="courts"
							/>
							<IntegratedGrouping />
							<GroupingPanel />
						</Scheduler>
					</Paper>
					}
				</Col>
			</Row>

			<Modal title="Basic Modal" visible={showConfirmModal} onOk={() => form.submit()} onCancel={() => setShowConfirmModal(false)}>
				<Form
					form={form}
					layout='vertical'
					onFinish={onFinish}
					onFinishFailed={() => console.log("onFinishFailed")}
					initialValues={{
						fullName: "",
						email: "",
						phoneNumber: "",
						gender: null,
						info: ""
					}}
				>
					<Row gutter={16}>
						<Col span={24}>
							<Form.Item
								name="fullName"
								label="User Name"
								rules={[
									{ required: true, message: "User name is required!" }
								]}
							>
								<Input placeholder="User Name" />
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={16}>
						<Col span={24}>
							<Form.Item
								name="email"
								label="User Email"
								rules={[
									{ required: true, message: "User email is required!" },
									{ type: "email", message: "Please enter a valid email address!" }
								]}
							>
								<Input placeholder="User Email" />
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={16}>
						<Col span={24}>
							<Form.Item
								name="phoneNumber"
								label="User phone number"
								rules={[
									{ required: true, message: "Phone number is required!" }
								]}
							>
								<Input placeholder="Phone Number" />
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={16}>
						<Col span={24}>
							<Form.Item
								name="gender"
								label="Gender"
								rules={[
									{ required: true, message: "Gender is required" }
								]}
							>
								<Select placeholder="User gender">
									<Option value="male">Male</Option>
									<Option value="female">Female</Option>
								</Select>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={16}>
						<Col span={24}>
							<Form.Item
								name="info"
								label="Additional Information"
							>
								<Input.TextArea showCount={false} autoSize={{ minRows: 5, maxRows: 10 }} />
							</Form.Item>
						</Col>
					</Row>
				</Form>
			</Modal>
		</Content>
	)

}